import { render, staticRenderFns } from "./ServiceData.vue?vue&type=template&id=eeba8204&scoped=true&"
import script from "./ServiceData.vue?vue&type=script&lang=js&"
export * from "./ServiceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeba8204",
  null
  
)

export default component.exports